export const FORM_FIELDS = {
  FIRST_VISIT: "firstVisit",
  MASTER_NAME: "masterName",
  NEXT_PORT: "nextPort",
  FINAL_DESTINATION: "finalDestination",
  VESSEL_CONDITION: "vesselCondition",
  DRAFT_FORE: "draftFore",
  DRAFT_AFT: "draftAft",
  REQUEST_ANCHORAGE_CLEARANCE: "requestAnchorageClearance",
  PRE_SAILING_MASTER_DECLARATION: "preSailingMasterDeclaration",
  DEPARTURE_CREW_LIST: "departureCrewList",
  CARGO_MANIFEST: "cargoManifest",
  CUSTOMS_CLEARANCE: "customsClearance",
  CUSTOMS_CLEARANCE_UPLOAD_HAPPENED: "customsClearanceUploadHappened",
  REMARKS: "remarks",
  ADDITIONAL_DOCUMENTS: "additionalDocuments",
  DOCUMENT_TYPE: "documentType",
  OTHER_SPECIFY_TYPE: "otherSpecifyType",
  DOCUMENT_NAME: "documentName",
  ISSUE_DATE: "issueDate",
  EXPIRY_DATE: "expiryDate",
  DOCUMENT_SUMMARY: "documentSummary",
} as const;

export const CREW_LIST_FIELDS = {
  NO: "No",
  FAMILY_NAME: "familyName",
  RANK_OR_RATING: "rankOrRating",
  NATIONALITY: "nationality",
  PLACE_OF_BIRTH: "placeOfBirth",
  DATE_OF_BIRTH: "dateOfBirth",
  GENDER: "gender",
  NATURE_OF_IDENTITY_DOCUMENT: "natureOfIdentityDocument",
  NUMBER_OF_IDENTITY_DOCUMENT: "numberOfIdentityDocument",
  ISSUING_STATE_OF_IDENTITY_DOCUMENT: "issuingStateOfIdentityDocument",
  EXPIRY_DATE: "expiryDate",
};

export const DEPARTURE_STATUS = {
  MARINE_DEPARTMENT_AWAITING_APPROVAL: "MARINE_DEPARTMENT_AWAITING_APPROVAL",
  PORT_TERMINAL_AWAITING_APPROVAL: "PORT_TERMINAL_AWAITING_APPROVAL",
  CUSTOMS_AWAITING_APPROVAL: "CUSTOMS_AWAITING_APPROVAL",
  REJECTED_BY_MARINE_DEPARTMENT: "REJECTED_BY_MARINE_DEPARTMENT",
  REJECTED_BY_PORT_TERMINAL: "REJECTED_BY_PORT_TERMINAL",
  REJECTED_BY_CUSTOMS: "REJECTED_BY_CUSTOMS",
  APPROVED_BY_MARINE_DEPARTMENT: "APPROVED_BY_MARINE_DEPARTMENT",
  CUSTOMS_PAYMENT_REQUIRED: "CUSTOMS_PAYMENT_REQUIRED",
  CANCELLED: "CANCELLED",
};

export const DEPARTURE_REJECTED_STATUS = [
  DEPARTURE_STATUS.REJECTED_BY_MARINE_DEPARTMENT,
  DEPARTURE_STATUS.REJECTED_BY_PORT_TERMINAL,
  DEPARTURE_STATUS.REJECTED_BY_CUSTOMS,
];
